import { Tooltip, Grid, useMediaQuery } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventIcon from '@mui/icons-material/Event';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Empty from 'component/commonComponents/empty/empty';
import React, { useContext } from 'react';
import parse from 'html-react-parser';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ThemeContext } from 'styled-components';
import DefaultPC from "../../../assets/images/placeholder-pc.png";
import EyeBrow from '../../../component/commonComponents/eyeBrow/eyeBrow';
import { NOT_APPLICABLE } from '../../../constants/originalState';
import HyperLink from '../../commonComponents/hyperLink/hyperLink';
import { StyledMydevicesDetail } from './mydevicesDetail.style';
import { StyledIcon } from '../../commonComponents/Icon/icon.style';
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { DEVICE_STATUS } from "../../../constants/originalState";

export interface IMydevicesDetailProps {
  itemDetail: {[key: string]: any},
  horizontal: boolean,
  onClickAction: (item: any) => void,
  isShowDetailDevice: boolean,
  isShowSpecifications: boolean,
  isShowDescription: boolean,
  isLableRefresh: boolean,
  isCopySerialNumber: boolean
  locale: any,
  pcManagement: any,
  isShowPrimaryLabel?: boolean
};

const MydevicesDetail = (props: IMydevicesDetailProps) => {

  const {
    itemDetail,
    horizontal,
    onClickAction,
    isShowDetailDevice,
    isShowSpecifications,
    isShowDescription,
    isLableRefresh,
    isCopySerialNumber,
    locale,
    pcManagement,
    isShowPrimaryLabel
  } = props;
  let arrActions = Object.keys(itemDetail.actions);
  let textActionsObject = null; 
  if(locale){
    const { textActions } = locale;
    textActionsObject = textActions;
  }
  let arrTextActions = [
    textActionsObject?.deviceRefresh,
    textActionsObject?.deviceReturn,
    textActionsObject?.reportBrokenDevice,
    textActionsObject?.iDontHaveThisDevice,
    textActionsObject?.acknowledgeMyDevice,
    textActionsObject?.reportMissingDevice
  ];

  const getPCLifecycle = pcManagement?.features.find((item: any) => item.key === 'pcLifecycle');
  const isCheckPCLifecycle = pcManagement?.enabled && Object.keys(getPCLifecycle).length > 0 && getPCLifecycle?.enabled;

  const theme = useContext(ThemeContext);
  const smUp = useMediaQuery(`(min-width:${theme.breakpoints.sm})`);
  const mdUp = useMediaQuery(`(min-width:${theme.breakpoints.md})`);
  const customView = { mobileView: smUp, tabletView: mdUp };

  const onClickCopy = () => {
    var copyText = document.getElementById("copy-txt") as HTMLInputElement;;
    copyText.select();
    navigator.clipboard.writeText(copyText.value);
  };

  if (!itemDetail.model_picture)
    itemDetail.model_picture = DefaultPC;

  const asset_Status =itemDetail.asset_function?.toUpperCase();
  const textAssetFunction =locale?.commonStatus && locale?.commonStatus[asset_Status]?` - ${locale?.commonStatus[asset_Status]}`:'';

  const isOrange = ['inactive'].includes(!!itemDetail.process_stage?.asset_eyebrow && itemDetail.process_stage?.asset_eyebrow.toLowerCase());

  let eyeBrowText ='';
  if(isShowPrimaryLabel && itemDetail?.process_stage){
    if(itemDetail?.process_stage?.stage?.toUpperCase() === DEVICE_STATUS.ELIGIBLE_FOR_REFRESH){
      eyeBrowText=`${locale?.readyForRefresh}${textAssetFunction}`;
    }
    else{
      eyeBrowText=`${!!itemDetail.process_stage?.asset_eyebrow  ? locale?.commonStatus[itemDetail.process_stage?.asset_eyebrow] : locale?.commonStatus ? locale?.commonStatus['IN USE']:''}${textAssetFunction}`;
    }
  }else{
    if(itemDetail?.process_stage?.stage?.toUpperCase() === DEVICE_STATUS.ELIGIBLE_FOR_REFRESH){
      eyeBrowText=`${locale?.readyForRefresh} - ${!!itemDetail.process_stage?.asset_eyebrow ? locale?.commonStatus?.[itemDetail.process_stage?.asset_eyebrow] : locale?.commonStatus ? locale?.commonStatus['IN USE']:''}`;
    }
    else{
      eyeBrowText=`${!!itemDetail.process_stage?.asset_eyebrow ? locale?.commonStatus[itemDetail.process_stage?.asset_eyebrow] : locale?.commonStatus ? locale?.commonStatus['IN USE']:''}`;
    }
  }

  const colorEyeBrow = isOrange ? theme.uptimeColors.deviceCardEyebrow.deviceCard.color : theme.uptimeColors.mainTheme.primary ;
  const backgroundEyeBrow = isOrange ? theme.uptimeColors.deviceCardEyebrow.deviceCard.background : theme.uptimeColors.mainTheme.light ;

  const iconEyeBrow= isLableRefresh && itemDetail?.process_stage?.stage?.toUpperCase() === DEVICE_STATUS.ELIGIBLE_FOR_REFRESH ? (
    <StyledIcon
      styleIcon={{
        fontSize: theme.uptimeFontSizes.desktop.fz5,
        color: isOrange ? theme.uptimeColors.deviceCardEyebrow.deviceCard.color : theme.uptimeColors.mainTheme.primary,
        width: theme.uptimeSpace[8],
        height:theme.uptimeSpace[8]
      }}
    >
      <RefreshOutlinedIcon />
    </StyledIcon>
  ): '';

  return (
    <StyledMydevicesDetail customView={customView} className="item-devices">
      <div className={horizontal ? "devices-detail-horizontal-inner inner" : "inner"}>
        <div
          className={
            (horizontal && !isShowDescription && !isShowSpecifications) ?
              "info-device-horizontal info-device" : "info-device"}
        >
          {eyeBrowText && <Grid container direction="row" alignItems="center">
            <EyeBrow
              position='initial'
              color={colorEyeBrow}
              backgroundColor={backgroundEyeBrow}
              text={eyeBrowText}
              marginBottom={theme.uptimeSpace[4]}
              icon={iconEyeBrow}
            />
          </Grid> }
          <div className={"info-device-thumbnail"}>
            <p className="option" id="lbl-mydevicedetail-manufacturer">{itemDetail.manufacturer}</p>
            <h3 className="ttl-device" id="lbl-mydevicedetail-model">{itemDetail.model}</h3>
            <div className="image-block">
              <img src={itemDetail.model_picture} alt={itemDetail.display_name} title={itemDetail.display_name} id="img-mydevicedetail-model_picture" />
            </div>
          </div>
          {isShowDetailDevice && <ul className="content">
            <li>
              <LocalOfferIcon />
              <span className="label label-serial">{locale?.serialNumber}</span>
              <span className="value" id="lbl-mydevicedetail-serial_number">{!!itemDetail.serial_number ? itemDetail.serial_number : NOT_APPLICABLE}</span>
              {isCopySerialNumber &&
                <>
                  <input type="text" defaultValue={!!itemDetail.serial_number ? itemDetail.serial_number : NOT_APPLICABLE} id="copy-txt" className="copy-txt" aria-label="Serial Number" />
                  <button className="btn-copy" onClick={onClickCopy} title={locale?.copy} id="btn-mydevicedetail-copy">
                    <FileCopyIcon />
                  </button>
                </>
              }
            </li>
            <li>
              <EventIcon />
              <span className="label label-owned">{locale?.ownedSince}</span>
              <span className="value" id="lbl-mydevicedetail-since">{itemDetail?.configuration?.since || NOT_APPLICABLE}</span>
            </li>
            <li>
              <AccessTimeIcon />
              <span className="label label-date">{locale?.lastScanned}</span>
              <span className="value" id="lbl-mydevicedetail-last_active">{itemDetail?.configuration?.lastActive || NOT_APPLICABLE}</span>
            </li>
            <li>
              <GpsFixedIcon />
              <span className="label label-os">{locale?.os}</span>
              <span className="value" id="lbl-mydevicedetail-os_licence">{itemDetail?.configuration?.osLicence || NOT_APPLICABLE}</span>
            </li>
          </ul>}
        </div>

        {(isShowDescription || isShowSpecifications || arrActions.length > 0) && <div className="info-device-detail">
          {isShowDescription && <div className="detail-block">
            <h4>{locale?.description}</h4>
            <div className="description-content" id="lbl-mydevicedetail-model_description">
              {!!itemDetail.model_description ? (
                parse(itemDetail.model_description)
              ) : (
                <Empty text={locale?.noDescription} id="lbl-mydevicedetail-no_description"/>
              )}
            </div>
          </div>}

          {isShowSpecifications && <div className="detail-block">
            <h4>{locale?.specifications}</h4>
            <div className="description-content" id="lbl-mydevicedetail-spec_os_version">
              {!!itemDetail.spec_os_version ? (
                parse(itemDetail.spec_os_version)
              ) : (
                <Empty text={locale?.noSpecifications} id="lbl-mydevicedetail-no_specifications" />
              )}
            </div>
          </div>}

          {isCheckPCLifecycle &&
            <div className="detail-block list-link">
              <ul>
                {arrActions.map((item, index) => {
                  const getKeyAction = getPCLifecycle?.features.find((k: any) => k.key === item);
                  return (
                    (!!getKeyAction && Object.keys(getKeyAction).length > 0 && getKeyAction?.enabled) &&
                      <React.Fragment key={item}>
                        {arrTextActions[index] ? itemDetail.actions[item] ?
                          <li>
                            <HyperLink kind="span" onClick={() => onClickAction(item)} label={arrTextActions[index]}></HyperLink>
                          </li>
                          :
                          <li>
                            <Tooltip title={locale?.tooltip}>
                              <span>
                                <HyperLink kind="span" disabled={true} label={arrTextActions[index]} ></HyperLink>
                              </span>
                            </Tooltip>
                          </li>
                        : null}
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
          }
        </div>}
      </div>
    </StyledMydevicesDetail>
  );
};

MydevicesDetail.defaultProps = {
  horizontal: false,
  isShowDetailDevice: true,
  isShowSpecifications: true,
  isShowDescription: true,
  isLableRefresh: true,
  isCopySerialNumber: false,
};

export default MydevicesDetail;
